export function calculateOpaqueColor(color: string, opacity: number): string {
  const hex = color.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const calc = (c: number): number =>
    Math.round(c * opacity + 255 * (1 - opacity));
  return `rgb(${calc(r)}, ${calc(g)}, ${calc(b)})`;
}
